import React, { PureComponent } from 'react';
import { TimePeriod } from '../../../../../model/CORE';
import TimeUtils from '../../../../../common/util/TimeUtils';

interface CurrentTimeLineProps {
    monitoredPeriod: TimePeriod;
    currentTime: Date;
}

export class CurrentTimeLine extends PureComponent<CurrentTimeLineProps> {
    render() {
        if (!this.props.monitoredPeriod || !this.props.currentTime) return null;

        const x =
            (100 * TimeUtils.diffInMs(this.props.currentTime.getTime(), this.props.monitoredPeriod.from.getTime())) /
            TimeUtils.diffInMs(this.props.monitoredPeriod.to.getTime(), this.props.monitoredPeriod.from.getTime());
        return (
            <line
                x1={x + '%'}
                y1="0"
                x2={x + '%'}
                y2="100%"
                stroke="#FFFFFF"
                strokeWidth="0.1em"
                strokeDasharray="0.2em 0.2em"
                shapeRendering="geometricPrecision"
            />
        );
    }
}
